// extracted by mini-css-extract-plugin
module.exports = {"ldsRipple":"Loading_ldsRipple__25x6z","lds-ripple":"Loading_lds-ripple__17L-T"};